import LessonBadge from './LessonBadge';

export default LessonBadge;
